import React, { createContext, useContext, useState } from 'react';

import { UserInfoCtx } from '../containers/CommonLayout/CommonLayout';
import { GRID_VIEW, LIST_VIEW } from '../pages/DiscoverPage/const';

type stateType = {
  searchState: any;
  setSearchState: Function;
  categoryTitle: string;
  setCategoryTitle: Function;
  openFiltersPanel: boolean;
  setOpenFiltersPanel: Function;
  tempSearchState: any;
  setTempSearchState: Function;
  discoverView: string;
  setDiscoverView: Function;
};

const STATE: stateType = {
  searchState: {},
  setSearchState: () => {},
  categoryTitle: '',
  setCategoryTitle: () => {},
  openFiltersPanel: false,
  setOpenFiltersPanel: () => {},
  tempSearchState: {},
  setTempSearchState: () => {},
  discoverView: LIST_VIEW,
  setDiscoverView: () => {},
};

export const DiscoverContext = createContext(STATE);

export const DiscoverController = ({ children }) => {
  const [searchState, setSearchState] = useState({});
  const [categoryTitle, setCategoryTitle] = useState('');
  const [openFiltersPanel, setOpenFiltersPanel] = useState(false);
  const [tempSearchState, setTempSearchState] = useState({});
  const { userInfo } = useContext(UserInfoCtx);
  const [discoverView, setDiscoverView] = useState(userInfo ? LIST_VIEW : GRID_VIEW);

  return (
    <DiscoverContext.Provider
      value={{
        searchState,
        setSearchState,
        categoryTitle,
        setCategoryTitle,
        openFiltersPanel,
        setOpenFiltersPanel,
        tempSearchState,
        setTempSearchState,
        discoverView,
        setDiscoverView,
      }}
    >
      {children}
    </DiscoverContext.Provider>
  );
};
